export class ConnectBYOApps200Response {
    'message';
    'workflowId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        },
        {
            "name": "workflowId",
            "baseName": "workflowId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectBYOApps200Response.attributeTypeMap;
    }
    constructor() {
    }
}
